export const states = [
    {
      value: 'M',
      label: 'Male'
    },
    {
      value: 'F',
      label: 'Female'
    },
  ];
  
  export const sources = [
    {
      value: 'S',
      label: 'Salary'
    },
    {
      value: 'B',
      label: 'Business'
    },
    {
      value: 'OT',
      label: 'Other source of Income'
    },
  ];
  export const periods = [
    {
      value: 'L',
      label: 'Less than 2 years'
    },
    {
      value: 'B',
      label: 'Between 2 - 5 years'
    },
    {
      value: 'BT',
      label: 'Between 5 - 10 years'
    },
    {
      value: 'M',
      label: 'More than 10 years'
    },
  ];
  export const mandates = [
    {
      value: 'A',
      label: 'Alone'
    },
    {
      value: 'E',
      label: 'Either to Sign'
    },
    {
      value: 'AL',
      label: 'All / Both to sign'
    },
    {
      value: 'OT',
      label: 'Other (Specify)'
    },
  ];
  
  export const incomes = [
    {
      value: 'B5',
      label: 'Below 500,000'
    },
    {
      value: 'B1',
      label: '500,000 - 1,000,000'
    },
    {
      value: 'B3',
      label: '1,000,000 - 3,000,000'
    },
    {
      value: 'A5',
      label: '3,000,000 - 5,000,000'
    },
    {
      value: 'B10',
      label: '5,000,000 - 10,000,000'
    },
    {
      value: 'B20',
      label: '10,000,000 - 20,000,000'
    },
    {
      value: 'B50',
      label: '20,000,000 - 50,000,000'
    },
    {
      value: 'A50',
      label: 'Above 50,000,000'
    },
  ];
  export const idTypes = [
    {
      value: 'N',
      label: 'National ID',
      idLable: 'National ID Number (ID)'
    },
    {
      value: 'P',
      label: 'Passport',
      idLable: 'Passport Number'
    },
    {
      value: 'R',
      label: 'Refugee ID',
      idLable: 'Refugee ID Number'
    },
  ];
  export const statuses = [
    {
      value: 'S',
      label: 'Single'
    },
    {
      value: 'M',
      label: 'Married'
    },
    {
      value: 'D',
      label: 'Divorced'
    },
    {
      value: 'W',
      label: 'Widowed'
    },
    {
      value: 'SP',
      label: 'Separated'
    },
  ];

  export const accountTypes = [
    {
      value: 'Business Account',
      label: 'Business Account'
    },
    {
      value: 'Joint Account',
      label: 'Joint Account'
    },
    {
      value: 'Personal Account',
      label: 'Personal Account'
    }
  ];